import React from 'react'

const LenderUnlockValue = () => {
  return (
    <section id="c-sectionLenderUnlock" className="c-sectionWrapper">
		<div className="container">
			<div className="c-sectionHeader">
				<h5 className="c-heading46Bold">Utilize <span className="c-colorFinOrange">FI-MEN</span> to unlock the value of financing</h5>
				<div className="row justify-content-lg-center">
					<div className="col-lg-8 col-md-12">						
						<p className="c-para22Regular">With Finayo, 'time for yes' is down to 5* minutes and 'time to cash' is less than 24 hours, making the lending process quick and easy.</p>
					</div>
				</div>
			</div>

			<div className="row c-lenderUnlockBoxes">
				<div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
					<div className="c-lenderUnlockBox c-lenderUnlockBox1">
						<div className="c-lubPercent">100%</div>
						<div className="c-lubInfo">End-to-End lending process</div>
					</div>
				</div>
				<div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
					<div className="c-lenderUnlockBox c-lenderUnlockBox2">
						<div className="c-lubPercent">100%</div>
						<div className="c-lubInfo">Real-Time Approval</div>
					</div>
				</div>
				<div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
					<div className="c-lenderUnlockBox c-lenderUnlockBox3">
						<div className="c-lubPercent">100%</div>
						<div className="c-lubInfo">Modern Approach for digitalize</div>
					</div>
				</div>
			</div>			
		</div>

		<div className="container-fluid c-lenderEnableBanksWrapper">
			<div className="row">
				<div className="container">
					<div className="row c-lenderEnableBanks">
						<div className="col-md-12 col-lg-9 offset-lg-3 col-xl-7 offset-xl-5">
							<div className="mb-5">
								<h5 className="c-heading46Bold">Enable Banks/NBFCs with <span className="c-colorFinOrange">FI-MEN</span> Technology</h5>											
								<p className="c-para22Regular">Integrate FI-MEN technology with banks and NBFCs</p>							
								<div className="c-lenderEnableBanksImage">
									<img src="./images/lender/lender_enable_banks.png" className="img-fluid" alt="" title="" />
								</div>
							</div>
							<div className="row c-lenderEnableBanksBoxRow">
								<img src="./images/lender/tech.jpg" className="mw-100" alt="" title="" />
								{/* <!-- <div className="col-sm-6 col-xs-12">
									<div className="c-lenderEnableBanksBox c-lebBox1">
										<div className="c-lebBoxTitle c-clrPurple">Application</div>
										<ul className="c-lebBoxList">
											<li>-KYC</li>
											<li>-ITR/Salary Slip</li>
											<li>-Bank Statement</li>
											<li>-Credit Bureau Info</li>
											<li>-Loan Eligibility</li>
										</ul>
									</div>
								</div>
								<div className="col-sm-6 col-xs-12">
									<div className="c-lenderEnableBanksBox c-lebBox2">
										<div className="c-lebBoxTitle c-clrGreen">Decision</div>
										<ul className="c-lebBoxList">
											<li>-Exception propensity analysis</li>
											<li>-Accept/Hold/Reject</li>
											<li>-Loan term allocation</li>
										</ul>
									</div>
								</div> --> */}
							</div>
							{/* <!-- <div className="row c-lenderEnableBanksBoxRow">
								<div className="col-sm-6 col-xs-12">
									<div className="c-lenderEnableBanksBox c-lebBox3">
										<div className="c-lebBoxTitle c-clrSkyBlue">AI-Inderwriting</div>
										<ul className="c-lebBoxList">
											<li>-Risk assessment</li>
											<li>-BSA,KYC</li>
											<li>-Individual Scorecard</li>
										</ul>
									</div>
								</div>
								<div className="col-sm-6 col-xs-12">
									<div className="c-lenderEnableBanksBox c-lebBox4">
										<div className="c-lebBoxTitle c-clrNavyBlue">Final Approval</div>
										<ul className="c-lebBoxList">
											<li>Approval/Rejection Write Legally binding & tradeable Loan agreements etc.</li>
										</ul>
										<div className="c-lebBoxSubTitle">Services</div>
										<ul className="c-lebBoxList">
											<li>Maintain loan account<br />Collection payments</li>
										</ul>
									</div>
								</div>
							</div> --> */}
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
  )
}

export default LenderUnlockValue